import { render, staticRenderFns } from "./simpleGradeItem.vue?vue&type=template&id=9ef0778c&scoped=true&"
import script from "./simpleGradeItem.vue?vue&type=script&lang=js&"
export * from "./simpleGradeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef0778c",
  null
  
)

export default component.exports